import React, { useCallback } from 'react'
import { useFieldArray } from 'react-hook-form'
import AddPersonIcon from 'transfix-icons/build/AddPersonIcon'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { IShipperApplicationContactRoles } from 'types/graphqlTypes'
import { ShipperContactFields } from '../../../../ShipperContacts/ShipperContactsModal/ShipperContactFields'
import { useEdiContactsFormContext } from '../hooks/useEdiContactsForm'

const useEdiContactsFormStyles = makeStyles(({ spacing }) => ({
  grid: {
    borderBottom: `1px solid ${brandColors.coolGray4}`,
    margin: spacing(1.5, 0),
  },
  buttonContainer: {
    marginLeft: spacing(1),
  },
  buttonIconText: {
    display: 'flex',
    gap: spacing(1),
    alignItems: 'center',
  },
}))

export const DEFAULT_EDI_CONTACT_VALUES = {
  role: IShipperApplicationContactRoles.EDI,
  name: '',
  email: '',
  secondaryEmail: '',
  phone: '',
  phoneExtension: '',
  notes: '',
}

export const EdiContactsForm = () => {
  const { control } = useEdiContactsFormContext()
  const classes = useEdiContactsFormStyles()
  const { append, fields: contacts = [], remove } = useFieldArray({
    control,
    name: 'contacts',
    keyName: 'key',
  })

  const addContactHandler = () => {
    append({
      ...DEFAULT_EDI_CONTACT_VALUES,
    })
  }

  const removeContactHandler = useCallback(
    (index: number) => {
      remove(index)
    },
    [remove]
  )

  return (
    <form data-test='EdiContactsForm'>
      {contacts.map((contact, index) => {
        const { key } = contact
        return (
          <ShipperContactFields
            key={key}
            index={index}
            contact={contact}
            onRemove={() => removeContactHandler(index)}
            isEdi
          />
        )
      })}
      <div className={classes.buttonContainer}>
        <Button color='tertiary' onClick={addContactHandler}>
          <div className={classes.buttonIconText}>
            <AddPersonIcon size='medium' />
            Add a New Contact
          </div>
        </Button>
      </div>
    </form>
  )
}
